import React from "react";
import { useParams } from "react-router-dom";
import employee from "../../../employee.json";
import "./EmployeeFormPage.css";

function EmployeeFormPage() {
  const { id } = useParams();
  const emp = employee.find((e) => e.id === id);

  if (!emp) {
    return <div className="container mt-5">Employee not found.</div>;
  }

  const handleSaveContact = (emp) => {
    const vCardData = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `N:${emp.lastName};${emp.firstName};;;`,
      `FN:${emp.firstName} ${emp.lastName}`,
      `TEL;TYPE=CELL:${emp.contactNumber}`,
      `EMAIL;TYPE=INTERNET:${emp.email}`,
      `ORG:MWeeb Inc.`,
      "END:VCARD",
    ].join("\r\n"); // Important for compatibility

    const blob = new Blob([vCardData], { type: "text/vcard;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${emp.firstName}_${emp.lastName}.vcf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="employee-card container shadow p-4 rounded bg-white">
      <div className="profile-card-wrapper text-center bg-light p-5 rounded mb-4 position-relative">
        <div className="profile-circle-wrapper mx-auto">
          <img
            src={emp.picture || "/an.jpeg"}
            alt="Profile"
            className="profile-img-circle"
          />
        </div>
        <h2 className="fw-bold mt-3 mb-1">
          {emp.firstName} {emp.middleName} {emp.lastName}
        </h2>
        <p className="text-muted mb-0">{emp.position}</p>
      </div>

      {/* CONTACT SECTION */}
      <div className="section contact-section mb-4">
        <h3 className="h5 fw-bold mb-3">Contact</h3>

        <a
          href={`tel:${emp.contactNumber}`}
          className="text-decoration-none text-dark"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
            <div className="d-flex align-items-start flex-grow-1 overflow-hidden">
              <div
                className="icon-box me-3 p-2"
                style={{ backgroundColor: "#fcd34d" }}
              >
                <i className="bi bi-telephone-fill text-white"></i>
              </div>
              <div>
                <p className="mb-0 text-muted small">Mobile</p>
                <p className="fw-bold mb-0">{emp.contactNumber}</p>
              </div>
            </div>
            <i className="bi bi-chevron-right text-muted ms-3"></i>
          </div>
        </a>

        <a
          href={`mailto:${emp.email}`}
          className="text-decoration-none text-dark"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
            <div className="d-flex align-items-start flex-grow-1 overflow-hidden">
              <div
                className="icon-box me-3 p-2"
                style={{ backgroundColor: "#4ade80" }}
              >
                <i className="bi bi-envelope-fill text-white"></i>
              </div>
              <div>
                <p className="mb-0 text-muted small">Email Address</p>
                <p style={{ maxWidth: "200px" }} className="fw-bold mb-0">
                  {emp.email}
                </p>
              </div>
            </div>
            <i className="bi bi-chevron-right text-muted ms-3"></i>
          </div>
        </a>

        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            emp.companyAddress
          )}`}
          className="text-decoration-none text-dark"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
            <div className="d-flex align-items-start flex-grow-1 overflow-hidden">
              <div
                className="icon-box me-3 p-2"
                style={{ backgroundColor: "#ef4444" }}
              >
                <i className="bi bi-geo-alt-fill text-white"></i>
              </div>
              <div>
                <p className="mb-0 text-muted small">Address</p>
                <p style={{ maxWidth: "200px" }} className="fw-bold mb-0">
                  {emp.companyAddress}
                </p>
              </div>
            </div>
            <i className="bi bi-chevron-right text-muted ms-3"></i>
          </div>
        </a>
      </div>

      {/* SOCIALS SECTION */}
      <div className="section socials-section">
        <h3 className="h5 fw-bold mb-3">Socials</h3>

        <a
          href={emp.facebook}
          className="text-decoration-none text-dark"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
            <div className="d-flex align-items-start flex-grow-1 overflow-hidden">
              <div
                className="icon-box me-3 p-2"
                style={{ backgroundColor: "#000" }}
              >
                <i className="bi bi-facebook text-white"></i>
              </div>
              <div className="overflow-hidden">
                <p className="mb-0 text-muted small">Facebook</p>
                <p
                  className="fw-bold mb-0 text-truncate"
                  style={{ maxWidth: "200px" }}
                >
                  {emp.facebook}
                </p>
              </div>
            </div>
            <i className="bi bi-chevron-right text-muted ms-3"></i>
          </div>
        </a>

        <a
          href={emp.linkedIn}
          className="text-decoration-none text-dark"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div className="d-flex align-items-start flex-grow-1 overflow-hidden">
              <div
                className="icon-box me-3 p-2"
                style={{ backgroundColor: "#0A66C2" }}
              >
                <i className="bi bi-linkedin text-white"></i>
              </div>
              <div className="overflow-hidden">
                <p className="mb-0 text-muted small">LinkedIn</p>
                <p
                  className="fw-bold mb-0 text-truncate"
                  style={{ maxWidth: "200px" }}
                >
                  {emp.linkedIn}
                </p>
              </div>
            </div>
            <i className="bi bi-chevron-right text-muted ms-3"></i>
          </div>
        </a>
        <div className="text-center mt-4">
          <button
            className="btn btn-success"
            onClick={() => handleSaveContact(emp)}
          >
            Save Contact
          </button>
        </div>
      </div>
    </div>
  );
}

export default EmployeeFormPage;
